import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

function SEO({ description, lang, meta, title, background }) {

  const { craft } = useStaticQuery(graphql`
    {
      craft {
        entries(type: "Settings") {
          ... on Craft_settings_settings_Entry {
            seoTitle
            seoImage {
              ... on Craft_minkAssets_Asset {
                url
              }
            }
            seoDescription
            metaTags
          }
        }
      }
    }
  `)
  const { seoTitle, seoDescription, seoImage, metaTags } = craft.entries[0]

  const metaTitle = title ? `${title} | ${seoTitle}` : seoTitle
  const metaDescription = description || seoDescription
  const metaImage = seoImage[0].url

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={metaTitle}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          name: 'keywords',
          content: metaTags
        },
        {
          property: `og:title`,
          content: metaTitle,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: 'og:image',
          content: metaImage,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: `@minkmgmt`,
        },
        {
          name: `twitter:title`,
          content: metaTitle,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ].concat(meta)}
      style={[{
        "cssText": `
          html {
            background-color: ${background};
          }
        `
      }]}
    />
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
  background: '#FFFFFF'
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string,
}

export default SEO
